<div class="operator-toolbar">
	<div class="day-navigation">
		<button
			type="button"
			aria-label="Προηγούμενη ημέρα"
			(click)="shiftDate(-1)"
		>
			<span class="icon icon--chevron-left" aria-hidden="true"></span>
		</button>
		<div class="date-picker">
			<button
				class="date-picker__trigger"
				type="button"
				aria-label="Επιλογή ημερομηνίας κρατήσεων"
				(click)="picker.open()"
			>
				{{ formatServiceDate(state.serviceDate()) }}
			</button>
			<input
				class="date-picker__native"
				aria-label="Ημερομηνία κρατήσεων"
				[matDatepicker]="picker"
				[value]="materialDateValue(state.serviceDate())"
				(dateChange)="changeMaterialDate($event.value)"
			/>
			<mat-datepicker #picker></mat-datepicker>
		</div>
		<button type="button" aria-label="Επόμενη ημέρα" (click)="shiftDate(1)">
			<span class="icon icon--chevron-right" aria-hidden="true"></span>
		</button>
	</div>
	<div class="search-bar">
		<label class="search-field">
			<span class="sr-only">Αναζήτηση κράτησης</span>
			<input
				type="search"
				[formControl]="searchControl"
				placeholder="Αναζήτηση"
			/>
		</label>
		<button
			class="create-button"
			type="button"
			aria-label="Νέο walk-in"
			(click)="createRequested.emit('walk_in')"
		>
			<span class="icon icon--person-walking-full" aria-hidden="true"></span>
		</button>
		<button
			class="create-button create-button--accent"
			type="button"
			aria-label="Νέα τηλεφωνική κράτηση"
			(click)="createRequested.emit('phone')"
		>
			<span class="icon icon--phone" aria-hidden="true"></span>
		</button>
	</div>
</div>

<div class="list-heading">
	<h1>Κρατήσεις</h1>
	<div class="list-heading__actions">
		<div
			class="live-sync"
			[class.live-sync--connected]="state.realtime()"
			role="status"
			[attr.aria-label]="
				state.realtime() ? 'Live Sync συνδεδεμένο' : 'Live Sync χωρίς σύνδεση'
			"
		>
			<span>Live Sync</span>
			<span class="live-sync__indicator" aria-hidden="true"></span>
		</div>
		<button
			class="refresh-button"
			type="button"
			aria-label="Ανανέωση κρατήσεων"
			(click)="state.loadDay()"
		>
			<span class="icon icon--refresh-cw" aria-hidden="true"></span>
		</button>
	</div>
</div>
